import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { languagesSelector } from '../../app/selectors/appSelectors';
import { generalInformationReadySelector, isCreatingSelector, editionSelector } from '../selectors/userSelectors';
import { generalInformationReady } from '../actions/userActions';
import GeneralInformation from '../components/GeneralInformation/GeneralInformation';

const mapStateToProps = createStructuredSelector({
    language: languagesSelector,
    ready: generalInformationReadySelector,
    isCreating: isCreatingSelector,
    edition: editionSelector
});

const mapDispatchToProps = { generalInformationReady };

export default
    withTranslation(['common', 'validations', 'users'])(
        connect(mapStateToProps, mapDispatchToProps)(withRouter(GeneralInformation))
    );
